<template>
  <div class="yahoo-conv-result-wrap">
    <div class="title-wrap">
      <h3 style="font-size: 14px; font-weight: unset;">Yahoo不動産(仲介)</h3>
      <template v-if="date">
        <p style="padding-left: 20px">【{{ date }}】</p>
      </template>
    </div>
    <div class="yahoo-conv-result-inner">
      <table>
        <thead>
          <tr>
            <th style="width: 60px;">状態名</th>
            <th style="width: 100px;">物件ID</th>
            <th style="width: 200px;">物件名</th>
            <th>メッセージ</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="data in result">
            <tr :key="data.id">
              <td>{{ data.state_name }}</td>
              <td>{{ buildingId(data.yahoo_shop_id, data.yahoo_b_id) }}</td>
              <td>{{ data.b_name }}</td>
              <td>{{ data.message }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      default: () => {},
      required: true,
    },
    date: {
      type: String,
      default: '',
      required: true,
    },
  },
  methods: {
    // yahoo物件IDから、物件IDを抽出
    buildingId(yahooId, yahooBuildingId) {
      const yahooIDStr = String(yahooId)
      const yahooBuildingIDStr = String(yahooBuildingId)
      const buildingID = yahooBuildingIDStr.replace(yahooIDStr, '')
      if (buildingID === yahooBuildingIDStr) {
        return 'undefined'
      } else {
        return buildingID
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.yahoo-conv-result-wrap {
  background-color: #f0f0f0;
  border: 1px solid #cfcfcf;
  font-size: 14px;
  white-space: pre-wrap;
  word-wrap: break-word;
  padding: 8px;
}
.title-wrap {
  display: flex;
  padding: 0 20px 8px;
}
.yahoo-conv-result-inner {
  background-color: #fff;
  max-height: 400px;
  overflow: scroll;
}
table {
  width: 100%;
  border-collapse: collapse;
}
thead {
  position: sticky;
  top: 0;
  background-color: #fff;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid #edecec;
  }
}
th,td {
  border: 1px solid #cfcfcf;
  padding: 5px;
}
</style>
